import { render, staticRenderFns } from "./volunteer-service-carousel.vue?vue&type=template&id=4e95cbce&scoped=true"
import script from "./volunteer-service-carousel.vue?vue&type=script&lang=js"
export * from "./volunteer-service-carousel.vue?vue&type=script&lang=js"
import style0 from "./volunteer-service-carousel.vue?vue&type=style&index=0&id=4e95cbce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e95cbce",
  null
  
)

export default component.exports